export const PUSH_TOKEN_LOCAL_STORAGE_KEY = "FARMACT_PUSH_TOKEN";
export const BACKGROUND_GEOLOCATION_TRACKING_SETTING_KEY = "trackBackgroundGeolocation";
